<template>
    <ValidationObserver ref="validationObserver" slim>
        <div class="forms-feature__form-wrapper">
            <div class="forms-feature__field-block" v-if="!IsClientKnown">
                <div class="forms-feature__field-block-title">{{Strings['Global.Address.ContactAddress']}}</div>
                <Address />
            </div>
            <div class="forms-feature__field-block">
                <div class="forms-feature__field-block-title">{{Strings['Forms.ManyUPs.Fuel.ProductFieldsTitle']}}</div>
                <div class="forms-feature__field-row">
                    <InputWithLabel :label="Strings['Forms.ManyUPs.Fuel.TotalLiters']"
                                    type="number"
                                    v-model="totalLiters"
                                    :postfix="Strings['Shop.UnitsLiter']"
                                    cssclass="migrol-form__input-wrapper--medium"
                                    rules="required|integer|min_value:0|max_value:200000" />
                </div>
                <div class="forms-feature__field-row">
                    <InputWithLabel :label="Strings['Forms.ManyUPs.Fuel.AmountUps']"
                                    type="number"
                                    v-model="numberUnloadingPoints"
                                    cssclass="migrol-form__input-wrapper--medium"
                                    rules="required|integer|min_value:0|max_value:50" />
                </div>
                <div class="forms-feature__field-row">
                    <ZipCityWithLabel :label="Strings['Forms.ManyUPs.Fuel.ZipCity']"
                                      :zipCity="deliveryZipCity"
                                      @change="data => updateDeliveryZipCity(data.zipcode, data.city, data.countryCode)"
                                      rules="required" />
                </div>
                <div class="forms-feature__field-row" v-if="ProductType === 'Heizoel'">
                    <SelectWithLabel v-model="product"
                                     :label="Strings['Forms.ManyUPs.Fuel.Product']"
                                     rules="required"
                                     :options="heatingOilOptions" />
                </div>
                <div class="forms-feature__field-row">
                    <SelectWithLabel v-model="deliveryPeriod"
                                     :label="Strings['Forms.ManyUPs.Fuel.DeliveryPeriod']"
                                     rules="required"
                                     :options="deliveryPeriodOptions" />
                </div>
                <div class="forms-feature__field-row">
                    <MyClimateInput v-model="myClimate" />
                </div>
                <div class="forms-feature__field-row">
                    <Comments />
                </div>
            </div>
            <div class="forms-feature__field-block forms-feature__field-block--no-separator">
                <div class="forms-feature__field-row">
                    <DSE v-model="dseAccepted" />
                </div>
            </div>

            <ServerErrorMessageList />

            <div class="migrol-form__buttons">
                <AjaxButton :isWaitingForAjax="isWaitingForAjax" :label="Strings['Forms.Submit']" @buttonClick="submitForm" cssclass="migrol-form__button--green" />
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex'
    import $ from 'jQuery';
    import Address from '../_common/Address';
    import Comments from '../_common/Comments';
    import ServerErrorMessageList from '../_common/ServerErrorMessageList'
    import MyClimateInput from '../_common/MyClimateInput'
    import { ValidationObserver } from 'VeeValidate'
    import { doValidation } from '@/utils/utils'

    export default {
        computed: {
            ...mapState([
                'Strings',
                'Enums',
                'ProductType',
                'AvailableDeliveryPeriods',
                'IsClientKnown'
            ]),
            ...mapGetters([
                'isWaitingForAjax'
            ]),
            dseAccepted: {
                get() { return this.$store.state.dseAccepted; },
                set(val) { this.$store.commit('setDseAccepted', val); }
            },
            totalLiters: {
                get() { return this.$store.state.manyUnloadingForFuel.totalLiters; },
                set(val) { this.$store.commit('manyUnloadingForFuel/setTotalLiters', val); }
            },
            numberUnloadingPoints: {
                get() { return this.$store.state.manyUnloadingForFuel.numberUnloadingPoints; },
                set(val) { this.$store.commit('manyUnloadingForFuel/setNumberUnloadingPoints', val); }
            },
            product: {
                get() { return this.$store.state.manyUnloadingForFuel.product; },
                set(val) { this.$store.commit('manyUnloadingForFuel/setProduct', val); }
            },
            myClimate: {
                get() { return this.$store.state.manyUnloadingForFuel.myClimate; },
                set(val) { this.$store.commit('manyUnloadingForFuel/setMyClimate', val); }
            },
            deliveryPeriod: {
                get() { return this.$store.state.manyUnloadingForFuel.deliveryPeriod; },
                set(val) { this.$store.commit('manyUnloadingForFuel/setDeliveryPeriod', val); }
            },
            heatingOilOptions() {
                return this.Enums['HeatingOilProducts'].map((val) => { return { text: val.text, id: val.value } });
            },
            deliveryZipCity: {
                get() {
                    return {
                        zipcode: this.$store.state.manyUnloadingForFuel.deliveryZip,
                        city: this.$store.state.manyUnloadingForFuel.deliveryCity,
                        countryCode: this.$store.state.manyUnloadingForFuel.deliveryCountryCode
                    }
                }
            },
            deliveryPeriodOptions() {
                return this.AvailableDeliveryPeriods.map((period) => { return { text: period.DisplayText, id: period.DisplayText } });
            }
        },
        methods: {
            ...mapActions([
                'TriggerGoal'
            ]),
            submitForm() {
                let formData = { ...this.$store.getters['baseData'], ...this.$store.state.manyUnloadingForFuel };
                var vm = this;
                doValidation(vm.$refs.validationObserver, () => {
                    vm.$store.commit('clearServerErrormessages');
                    vm.$store.commit('increasePendingAjaxCalls');
                    $.post({
                        url: '/migrolapi/' + window.CONFIG.language + '/forms/SubmitManyUnloadingForFuelForm',
                        data: JSON.stringify(formData),
                        contentType: 'application/json'
                    })
                        .done((response) => {
                            if (!response.Success)
                                vm.manageError(response);
                            else {
                                if (vm.ProductType === 'Heizoel') {
                                    this.$router.push('/thanks-oil').catch(() => { });
                                } else {
                                    this.$router.push('/thanks-diesel').catch(() => { });
                                }
                                vm.TriggerGoal();
                            }
                        })
                        .fail(() => {
                            vm.manageError(null);
                        })
                        .always(function () {
                            vm.$store.commit('decreasePendingAjaxCalls');
                        });
                });
            },
            manageError(response) {
                if (!response || !response.ErrorMessages || response.ErrorMessages.length == 0)
                    this.$store.commit('addServerErrormessages', [{ TextKey: 'Shop.Errors.GenericError' }]);
                else
                    this.$store.commit('addServerErrormessages', response.ErrorMessages);
            },
            updateDeliveryZipCity(zipValue, cityValue, countryCodeValue) {
                this.$store.commit('manyUnloadingForFuel/setDeliveryZipAndCity', { zip: zipValue, city: cityValue, countryCode: countryCodeValue });
            }
        },
        components: {
            Address,
            ValidationObserver,
            Comments,
            ServerErrorMessageList,
            MyClimateInput
        }
    };
</script>